"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderWithConfig = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ConfigLoader = require("./ConfigLoader");
var _state = require("../../state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ProviderWithConfig = props => {
  const {
    store: passedStore,
    silent: isSilent = false,
    children
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: passedStore || _state.store
  }, /*#__PURE__*/_react.default.createElement(_ConfigLoader.ConfigLoader, {
    silent: isSilent
  }, children));
};
exports.ProviderWithConfig = ProviderWithConfig;